import React from 'react';

function ServiceArea() {
  const primaryAreas = [
    'Pinellas County',
    'Hillsborough County',
    'Pasco County',
    'Hernando County',
    'Polk County',
    'Manatee County',
  ];

  return (
    <section className="bg-white py-8 md:py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-900 text-center mb-4">
          Service Area
        </h2>
        <p className="text-xl text-brand-700 text-center mb-8 max-w-2xl mx-auto">
          Serving the Greater Tampa Bay Area and surrounding counties
        </p>

        {/* Service Area Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto mb-8">
          {primaryAreas.map((area) => (
            <div
              key={area}
              className="bg-white rounded-lg p-4 shadow-md text-center border-2 border-brand-200 hover:border-water-500 transition-colors"
            >
              <span className="text-brand-900 font-semibold flex items-center justify-center">
                <span className="text-nature-500 mr-2">✓</span>
                {area}
              </span>
            </div>
          ))}
        </div>

        {/* Map placeholder - using a styled box for now */}
        <div className="max-w-4xl mx-auto mb-8">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-brand-200">
            <div className="bg-gradient-to-br from-water-100 to-water-200 p-8 md:p-12 text-center">
              <div className="text-6xl mb-4">🗺️</div>
              <h3 className="text-2xl font-bold text-brand-900 mb-2">
                Tampa Bay Area & Beyond
              </h3>
              <p className="text-brand-700">
                Proudly serving communities across West Central Florida
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-lg text-brand-700 mb-4">
            Not sure if we serve your area?
          </p>
          <a
            href="tel:+17272773366"
            className="inline-block bg-water-600 hover:bg-water-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-200 min-h-[48px]"
          >
            Call Joe to Find Out: (727) 277-3366
          </a>
        </div>
      </div>
    </section>
  );
}

export default ServiceArea;
